export const formData = [
    {
        id: 0,
        type: 'bottomInput',
        text: 'ФИО',
        placeholder: '',
    },
    {
        id: 1,
        type: 'bottomInput',
        text: 'Дата рождения',
        placeholder: '(число, месяц, год)',
    },
    {
        id: 2,
        type: 'bottomInput',
        text: 'Место рождения',
        placeholder: '',
    },
    {
        id: 3,
        type: 'bottomInput',
        text: 'Семейное положение',
        placeholder: '',
    },
    {
        id: 4,
        type: 'bottomInput',
        text: 'Дети',
        placeholder: '(количество, возраст)',
    },
    {
        id: 5,
        type: 'bottomInput',
        text: 'Адрес регистрации',
        placeholder: '',
    },
    {
        id: 6,
        type: 'bottomInput',
        text: 'Адрес проживания',
        placeholder: '',
    },
    {
        id: 7,
        type: 'bottomInput',
        text: 'Контактный телефон',
        placeholder: '',
    },
    {
        id: 8,
        type: 'bottomInput',
        text: 'Адрес электронной почты',
        placeholder: '',
    },
    {
        id: 9,
        type: 'table',
        text: 'Образование (среднее профессиональное, высшее):',
        columns: [
            {
                id: 0,
                text: 'Год поступления и окончания',
            },
            {
                id: 1,
                text: 'Учебное заведение',
            },
            {
                id: 2,
                text: 'Факультет, специальность',
            },
            {
                id: 3,
                text: 'Город обучения',
            },
        ],
    },
    {
        id: 10,
        type: 'table',
        text: 'Опыт работы',
        columns: [
            {
                id: 0,
                text: 'Период работы (м.г/м.г)',
            },
            {
                id: 1,
                text: 'Должность, место работы',
            },
            {
                id: 2,
                text: 'Город, в котором работали',
            },
            {
                id: 3,
                text: 'Причина поиска (смены) работы',
            },
        ],
    },
    {
        id: 11,
        type: 'textarea',
        text: 'Перечислите три главных личных результата, достижением которых Вы гордитесь.',
        placeholder: '',
    },
    {
        id: 12,
        type: 'textarea',
        text: 'Какими ключевыми профессиональными навыками Вы обладаете?',
        placeholder: '',
    },
    {
        id: 13,
        type: 'textarea',
        text: 'Ваши ожидания от участия в проекте «Команда изменений»',
        placeholder: '',
    },
    {
        id: 14,
        type: 'textarea',
        text: 'Увлечения, хобби:',
        placeholder: '',
    },
    {
        id: 15,
        type: 'textarea',
        text: 'Напишите эссе: «Какой проект я предложил (-а) бы для развития Казани и почему?»',
        placeholder: '',
    },
    {
        id: 16,
        type: 'checkboxAgreement',
        text: 'Я подтверждаю достоверность всего изложенного выше и не возражаю против проверки.',
        agreements: [{ id: 0, text: 'Я подтверждаю достоверность всего изложенного выше и не возражаю против проверки.' }],
        max: 1,
    },
    {
        id: 17,
        type: 'checkboxAgreement',
        text: 'Я согласен пройти оценку компетенций и не претендую на получение материалов и результатов оценки.',
        agreements: [{ id: 0, text: 'Я согласен пройти оценку компетенций и не претендую на получение материалов и результатов оценки.' }],
        max: 1,
    },
    {
        id: 18,
        type: 'checkboxAgreement',
        text: 'Я согласен на обработку моих персональных данных.',
        agreements: [{ id: 0, text: 'Я согласен на обработку моих персональных данных.' }],
        max: 1,
    },
]

export const sendInfo = {
    serviceId: 'service_j13udke',
    templateId: 'template_zim9zhl',
    publicKey: 'f0XtLro7aLnWYVrrl',
}
